import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './forgot-password.html',
  styleUrls: ['./forgot-password.scss']
})
export class ForgotPasswordComponent {

  email = '';
  loading = false;
  message = '';
  error = '';

  apiUrl = 'https://superbangladesh-api-1.onrender.com';

  constructor(
    private http: HttpClient,
    public languageService: LanguageService
  ) {}

  t(key: string): string {
    return this.languageService.translate(key);
  }

  submit() {

    this.message = '';
    this.error = '';

    if (!this.email) {
      this.error = this.t('enterEmail');
      return;
    }

    this.loading = true;

    this.http.post<any>(
      `${this.apiUrl}/api/auth/forgot-password`,
      { email: this.email }
    ).subscribe({

      // ✅ Backend সবসময় একই generic message পাঠায় (security: email
      // exist করে কিনা তা leak করে না), তাই সেটাকে ignore করে
      // frontend নিজের ভাষা অনুযায়ী অনুবাদ করা message দেখায়।
      next: () => {
        this.loading = false;
        this.message = this.t('resetLinkSentIfExists');
      },

      error: () => {
        this.loading = false;
        this.error = this.t('somethingWentWrongTryAgain');
      }
    });
  }
}
